import { render } from "./NfseServices.vue?vue&type=template&id=c2482888"
import script from "./NfseServices.vue?vue&type=script&lang=js"
export * from "./NfseServices.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__